module.exports = __webpack_public_path__ + "static/img/eagle_item_title_bg.4b03b04a.png";